import {AutoComplete, Input, Select, Tooltip,} from "antd";
import {CloseIconSearch, DetailIcon, SearchIcon,} from "../../../asset";
import style from "./DeliveryPaymentList.module.css";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {ROUTES} from "../../../constant/routeConstant";
import axios from "axios";
import {GROLOG_ORDER_URL, GROLOG_URL,} from "../../../constant/apiConstant.js";
import CustomPaging from "../../../component/pagination/pagination";
import CustomTableScroll from "../../../component/table/CustomTableScroll";
import Breadcrumbs from "../../../component/page-components/breadcumbs/breadcumbs";
import {useSelector} from "react-redux";
import {dropdownCustom, LoadingOption, selectOption} from "../../../component/select/SelectOption";

const DeliveryPaymentList = (props) => {
  const {token, client_id, grolog_account_id, userId} = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const {t} = useTranslation();
  const [listData, setListData] = useState([]);
  const navigate = useNavigate();
  const [dropdownDepot, setDropdownDepot] = useState([]);
  const [depot, setDepot] = useState();
  const [depotName, setDepotName] = useState();
  const [depot1, setDepot1] = useState();
  const [depotName1, setDepotName1] = useState();
  const [pageDepot, setPageDepot] = useState(1);
  const [limitDepot, setLimitDepot] = useState(10);
  const [filterDepot, setFilterDepot] = useState("");
  const [searchValueDepot, setSearchValueDepot] = useState("");
  const [dropdownCustomer, setDropdownCustomer] = useState([]);
  const [customer, setCustomer] = useState();
  const [customerName, setCustomerName] = useState();
  const [customer1, setCustomer1] = useState();
  const [customerName1, setCustomerName1] = useState();
  const [pageCustomer, setPageCustomer] = useState(1);
  const [limitCustomer, setLimitCustomer] = useState(10);
  const [filterCustomer, setFilterCustomer] = useState("");
  const [searchValueCustomer, setSearchValueCustomer] = useState("");
  const [dropdownSeller, setDropdownSeller] = useState([]);
  const [seller, setSeller] = useState();
  const [sellerName, setSellerName] = useState();
  const [seller1, setSeller1] = useState();
  const [sellerName1, setSellerName1] = useState();
  const [pageSeller, setPageSeller] = useState(1);
  const [limitSeller, setLimitSeller] = useState(10);
  const [filterSeller, setFilterSeller] = useState("");
  const [searchValueSeller, setSearchValueSeller] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState();
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState("");
  const [searchRecommendation, setSearchRecommedation] = useState("");
  const [listRecommendation, setListRecommendation] = useState([]);
  const [load, setLoad] = useState(false);
  const [loading, setLoading] = useState(false);
  const api = GROLOG_ORDER_URL;

  // const refresh = useSelector((state) => state.auth.refresh);

  useEffect(() => {
    fetchData();
  }, [page, limit, depot, depotName, customer, customerName, seller, sellerName]);

  /*
  * Filter in Delivery Payment
  * date rng 2023-01-01T00:00:00Z>>2023-01-01T23:59:59Z, depot_id eq 1, customer_id eq 1, distributor_id eq 1, order_number||si_number lk todo
  *
  */

  const fetchData = async (data, pages) => {
    let tkn = token;
    setLoad(true);

    let resDepot = await doGetParam(
      `/depot-configuration/dropdown?page=1&limit=10&${param}`,
      tkn
    );
    let listDepot = resDepot?.data?.payload?.data;

    listDepot?.unshift({
      id: -1,
      value: "All Depot"
    });

    let resCust = await doGetParam(
      `/customer/dropdown?page=1&limit=10&order=id desc&filter=depot_id eq ${
        depot ? depot : listDepot[1]?.id
        }&${param}`,
      tkn
    );
    let listCust = resCust?.data?.payload?.data;

    listCust?.unshift({
      id: -1,
      value: "All Customer"
    });

    let resSeller = await doGetParam(
      `/seller/dropdown?page=1&limit=10&order=id desc&filter=depot_id eq ${
        depot ? depot : listDepot[0]?.id
        }&${param}`,
      tkn
    );

    let listSeller = resSeller?.data?.payload?.data;

    listSeller?.unshift({
      id: -1,
      value: "All Seller"
    });

    let res = await doGet(
      `/delivery-payment?page=${
        pages ? pages : page
        }&limit=${limit}&filter=seller_id eq ${
        seller ? seller : listSeller[0]?.id
        }, customer_id eq ${
        customer ? customer : listCust[0]?.id
        }, depot_id eq ${
        depot ? depot : listDepot[0]?.id
        }${
        !isSearch
          ? ""
          : search
          ? ", order_no||sales_invoice_number lk " + search
          : data
            ? ", order_no||sales_invoice_number lk " + data
            : ""
        }`,
      tkn
    );
    let init = await doGet(
      `/delivery-payment/initiate?page=${
        pages ? pages : page
        }&limit=${limit}&filter=seller_id eq ${
        seller ? seller : listSeller[0]?.id
        }, customer_id eq ${
        customer ? customer : listCust[0]?.id
        }, depot_id eq ${
        depot ? depot : listDepot[0]?.id
        }${
        !isSearch
          ? ""
          : search
          ? ", order_no||sales_invoice_number lk " + search
          : data
            ? ", order_no||sales_invoice_number lk " + data
            : ""
        }&${param}`,
      tkn
    );

    const currentDepot = [...dropdownDepot];
    if (listDepot !== null && listDepot.length !== undefined) {
      setDropdownDepot(selectOption(currentDepot, listDepot, "value"));
    }
    setDepot1(listDepot[0]?.id);
    setDepotName1(listDepot[0]?.value);

    const currentCust = [...dropdownCustomer];
    if (listCust !== null && listCust.length !== undefined) {
      setDropdownCustomer(selectOption(currentCust, listCust, "value"));
    }
    if (listCust) {
      setCustomer1(listCust[0]?.id);
      setCustomerName1(listCust[0]?.value);
    }

    const currentSeller = [...dropdownSeller];
    if (listSeller !== null && listSeller.length !== undefined) {
      setDropdownSeller(selectOption(currentSeller, listSeller, "value"));
    }
    if (listSeller) {
      setSeller1(listSeller[0]?.id);
      setSellerName1(listSeller[0]?.value);
    }

    setListData(res?.data?.payload?.data);
    setInitiate(init?.data?.payload?.data);
    setLoad(false);
  };

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = {Authorization: tkn};
    const request = {url, method, headers, params};
    return axios(request);
  };

  const doGetParam = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = GROLOG_URL + endpoint;
    const method = "GET";
    const headers = {Authorization: token};
    const request = {url, method, headers, params};
    return axios(request);
  };

  const getListDepot = async (page, limit, value) => {
    let resDepot = await doGetParam(
      `/depot-configuration/dropdown?page=${page}&limit=${limit}${value ? `&filter=depot_name lk ${value}` : ""}&${param}`,
      token
    );
    let listDepot = resDepot?.data?.payload?.data;
    listDepot?.unshift({
      id: -1,
      value: "All Depot"
    });
    const currentDepot = [...dropdownDepot];
    if (listDepot !== null && listDepot.length !== undefined) {
      setDropdownDepot(selectOption(currentDepot, listDepot, "value"));
    }
  };

  const getListCustomer = async (page, limit, value) => {
    let resCust = await doGetParam(
      `/customer/dropdown?page=${page}&limit=${limit}${value ? `&filter=depot_id eq ${
        depot ? depot : depot1
        }
      , customer_name lk ${value}` : `&filter=depot_id eq ${
        depot ? depot : depot1}`}&${param}`,
      token
    );
    let listCust = resCust?.data?.payload?.data;
    const currentCust = [...dropdownCustomer];
    if (listCust !== null && listCust.length !== undefined) {
      setDropdownCustomer(selectOption(currentCust, listCust, "value"));
    }
  };

  const getListSeller = async (page, limit, value) => {
    let resSeller = await doGetParam(
      `/seller/dropdown?page=${page}&limit=${limit}${value ? `&filter=depot_id eq ${
        depot ? depot : depot1
        }
      , distributor_name lk ${value}` : `&filter=depot_id eq ${
        depot ? depot : depot1}`}&${param}`,
      token
    );
    let listSeller = resSeller?.data?.payload?.data;
    const currentSeller = [...dropdownSeller];
    if (listSeller !== null && listSeller.length !== undefined) {
      setDropdownSeller(selectOption(currentSeller, listSeller, "value"));
    }
  };

  const handleChange = (value, field) => {
    if (field === "depot") {
      setDepot(value);
      setDepotName(value);
      setCustomer(customer1);
      setCustomerName(customerName1);
      setSeller(seller1);
      setSellerName(sellerName1);
    } else if (field === "customer") {
      setCustomer(value);
      setCustomerName(value);
    } else {
      setSeller(value);
      setSellerName(value);
    }
    setLoading(false)
  };

  const onScroll = (event, field) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight || target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight + 1 &&
      !loading
    ) {
      setLoading(true);
      if (field === "depot") {
        setPageDepot(pageDepot + 1);
        getListDepot(pageDepot, limitDepot, filterDepot)
      } else if (field === "customer") {
        setPageCustomer(pageCustomer + 1);
        getListCustomer(pageCustomer, limitCustomer, filterCustomer)
      } else {
        setPageSeller(pageSeller + 1);
        getListSeller(pageSeller, limitSeller, filterSeller)
      }
      target.scrollTo(0, target.scrollHeight);
    }
  };

  const onChange = (event, field) => {
    const {value} = event.target;
    const resetPage = 1;
    let filterSearch = value && `${value}`;
    if (field === "depot")
      setSearchValueDepot(value);
    else if (field === "customer")
      setSearchValueCustomer(value);
    else
      setSearchValueSeller(value)
    let filters = [filterSearch];
    filters = filters.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filters = filters.length !== 0 ? filters.join(", ") : undefined;
    const resetFilter = filters;
    setDropdownDepot([]);
    if (field === "depot") {
      if (value) {
        setDropdownDepot([]);
        setFilterDepot(filters);
        setPageDepot(resetPage);
        setTimeout(() => {
          getListDepot(1, limitDepot, filters)
        }, 256);
      } else if (!value) {
        setLoading(true);
        setDropdownDepot([]);
        setFilterDepot(resetFilter);
        setPageDepot(resetPage);
        getListDepot(1, limitDepot, filters)
      }
    } else if (field === "customer") {
      if (value) {
        setDropdownCustomer([]);
        setFilterCustomer(filters);
        setPageCustomer(resetPage);
        setTimeout(() => {
          getListCustomer(1, limitCustomer, filters)
        }, 256);
      } else if (!value) {
        setLoading(true);
        setDropdownCustomer([]);
        setFilterCustomer(resetFilter);
        setPageCustomer(resetPage);
        getListCustomer(1, limitCustomer, filters)
      }
    } else {
      if (value) {
        setDropdownSeller([]);
        setFilterSeller(filters);
        setPageSeller(resetPage);
        setTimeout(() => {
          getListSeller(1, limitSeller, filters)
        }, 256);
      } else if (!value) {
        setLoading(true);
        setDropdownSeller([]);
        setFilterSeller(resetFilter);
        setPageSeller(resetPage);
        getListSeller(1, limitSeller, filters)
      }
    }
    setLoading(false)

  };

  const handleDetail = (id) => {
    navigate(ROUTES.DELIVERY_PAYMENT.DETAIL, {state: id});
  };

  const dataSource = listData
    ? listData?.map((result) => ({
      payment_date: (
        <span className="font-roboto text-lg text-[#222222]">
            {result?.payment_date}
          </span>
      ),
      depot_name: (
        <span className="font-roboto text-lg text-[#222222]">
            {result?.depot_name}
          </span>
      ),
      customer_name: (
        <span className="font-roboto text-lg text-[#222222]">
            {result?.customer_name}
          </span>
      ),
      order_id: (
        <span className="font-roboto text-lg text-[#222222]">
            {result?.order_id}
          </span>
      ),
      order_number: (
        <span className="font-roboto text-lg text-[#222222]">
            {result?.order_number}
          </span>
      ),
      seller_name: (
        <span className="font-roboto text-lg text-[#222222]">
            {result?.seller_name}
          </span>
      ),
      si_number: (
        <span className="font-roboto text-lg text-[#222222]">
            {result?.sales_invoice_number}
          </span>
      ),
      payment: (
        <span className="font-roboto text-lg text-[#222222]">
            {result?.payment_order_date}
          </span>
      ),
      action: (
        <div className="flex gap-[26px]">
          <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
            <button
              onClick={() => handleDetail(result?.order_id)}
            >
              <img src={DetailIcon} alt="det"/>
            </button>
          </Tooltip>
        </div>
      ),
    }))
    : null;

  const ListColumn = [
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Payment Date")}
        </span>
      ),
      dataIndex: "payment_date",
      key: "payment_date",
      render: (payment_date) => <span>{payment_date}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Depot Name")}
        </span>
      ),
      dataIndex: "depot_name",
      key: "depot_name",
      // sorter: {
      //     compare: (a, b) => a.plan_name.localeCompare(b.plan_name)

      // },
      render: (depot_name) => <span>{depot_name}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Customer Name")}
        </span>
      ),
      dataIndex: "customer_name",
      key: "customer_name",
      render: (customer_name) => <span>{customer_name}</span>,
    },

    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Order ID")}
        </span>
      ),
      dataIndex: "order_id",
      key: "order_id",
      render: (order_id) => <span>{order_id}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Order Number")}
        </span>
      ),
      dataIndex: "order_number",
      key: "order_number",
      render: (order_number) => <span>{order_number}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Seller Name")}
        </span>
      ),
      dataIndex: "seller_name",
      key: "seller_name",
      render: (seller_name) => <span>{seller_name}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Sales Invoice Number")}
        </span>
      ),
      dataIndex: "si_number",
      key: "si_number",
      render: (si_number) => <span>{si_number}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Payment (Order Group)")}
        </span>
      ),
      dataIndex: "payment",
      key: "payment",
      render: (payment) => <span>{payment}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:ACTION_FIELD")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      fixed: "right",
      width: "108px",
      render: (action) => action,
    },
  ];

  const handlePagination = (a, b) => {
    if (a && b) {
      setPage(a);
      setLimit(b);
    } else {
    }
  };

  const fetchRecommendation = async (page, limit, filters,) => {
    if (filters.length >= 1) {
      let res = await doGet(
        `/all-trip/search?page=1&limit=10&filter=depot_id eq ${
          depot ? depot : depot1
          }, trip_name lk ${filters}&${param}`,
        token
      );
      setListRecommendation(res?.data?.payload?.data);
    }
  };

  const onSearchRecommendation = async (value) => {
    setSearchRecommedation(value);
    setIsSearch(true);
    if (value) {
      setSearchRecommedation(value);
      await fetchRecommendation(1, 10, value);
    } else {
    }
  };

  const onSelectRecommendation = (data) => {
    setSearch(data);
    fetchData(data);
    setIsSearch(false);
  };

  const onClearRecommendation = () => {
    setIsSearch(false);
    setSearch(null);
    setSearchRecommedation("");
    setListRecommendation([]);
    fetchData();
  };

  const options = listRecommendation && listRecommendation.map((item) => ({
    value: item.value,
    label: item.value,
  }));

  return (
    <>
      <div className="p-[24px] flex flex-col gap-[24px]">
        <div>
          <Breadcrumbs
            jmlLevel={2}
            menuLevel1={`Report`}
            menuLevel2={`Delivery Payment`}
          />

          <h1 className="font-sans-bold text-2xl mt-[8px] mb-[32px]" id="title">
            {t("Delivery Payment")}
          </h1>

          <div
            className={
              style.headerContainer + " flex justify-between items-center"
            }
          >
            <div className="flex h-[47px] mr-1">
              <AutoComplete
                options={options}
                value={searchRecommendation}
                onChange={(value) => onSearchRecommendation(value)}
                onSelect={(value) => onSelectRecommendation(value)}
                //  allowClear={true}
              >
                <Input
                  placeholder={t("Search by Order or SI Number")}
                  suffix={
                    <img
                      onClick={search ? () => onClearRecommendation() : null}
                      src={search ? CloseIconSearch : SearchIcon}
                      alt="search"
                    />
                  }
                  value={searchRecommendation}
                  width={350}
                  className="w-[350px] h-[47px]"
                />
              </AutoComplete>
              <Select
                className={style.selectContainer + " ml-3 w-[280px]"}
                value={depotName ? depotName : depotName1}
                onChange={(id) => handleChange(id, "depot")}
                onPopupScroll={(e) => onScroll(e, "depot")}
                dropdownRender={(menu) =>
                  dropdownCustom(
                    menu,
                    (value) => onChange(value, "depot"),
                    searchValueDepot
                  )
                }
              >
                {!loading
                  ? dropdownDepot
                  : [...dropdownDepot, LoadingOption()]}
              </Select>
              <Select
                className={style.selectContainer + " ml-3 w-[280px]"}
                value={customerName ? customerName : customerName1}
                onChange={(id) => handleChange(id, "customer")}
                onPopupScroll={(e) => onScroll(e, "customer")}
                dropdownRender={(menu) =>
                  dropdownCustom(
                    menu,
                    (value) => onChange(value, "customer"),
                    searchValueCustomer
                  )
                }
              >
                {!loading
                  ? dropdownCustomer
                  : [...dropdownCustomer, LoadingOption()]}
              </Select>
              <Select
                className={style.selectContainer + " ml-3 w-[280px]"}
                value={sellerName ? sellerName : sellerName1}
                onChange={(id) => handleChange(id, "seller")}
                onPopupScroll={(e) => onScroll(e, "seller")}
                dropdownRender={(menu) =>
                  dropdownCustom(
                    menu,
                    (value) => onChange(value, "seller"),
                    searchValueSeller
                  )
                }
              >
                {!loading
                  ? dropdownSeller
                  : [...dropdownSeller, LoadingOption()]}
              </Select>
            </div>
          </div>
        </div>

        {/* {!load ? ( */}
        <div className={style.tableContainer}>
          <CustomTableScroll
            columns={ListColumn}
            // scroll={{x:1500}}
            data={dataSource}
            showPagination={false}
          />
          <div className={style.containerPagination + " mt-[-45px]"}>
            <CustomPaging
              idLimit="ddlrowsperpagemustselllist"
              idPagination="btnpaginationmustselllist"
              // pagination={pagination}
              size="small"
              current={page}
              defaultCurrent={page}
              pageSize={limit}
              total={initiate && initiate?.count_data}
              pageSizeOptions={initiate && initiate?.valid_limit}
              onShowSizeChange={() => handlePagination()}
              handlePaging={(a, b) => handlePagination(a, b)}
              title={t("COMMON:ROW_PAGE")}
            />
          </div>
        </div>
        {/* ) : (
          "..loading"
        )} */}
      </div>
    </>
  );
};

export default DeliveryPaymentList;
